import { MyServicesContainer } from '../containers/MyServicesContainer/index'

export const MyServicesPage = () => (
    <MyServicesContainer/>
)